import ModalLogin from './ModalLogin';

export default ModalLogin;

export { type Props } from './ModalLogin';
